import { render, staticRenderFns } from "./Brand.vue?vue&type=template&id=29be52e4&scoped=true"
import script from "./Brand.vue?vue&type=script&lang=js"
export * from "./Brand.vue?vue&type=script&lang=js"
import style0 from "./Brand.vue?vue&type=style&index=0&id=29be52e4&lang=scss"
import style1 from "./Brand.vue?vue&type=style&index=1&id=29be52e4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29be52e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29be52e4')) {
      api.createRecord('29be52e4', component.options)
    } else {
      api.reload('29be52e4', component.options)
    }
    module.hot.accept("./Brand.vue?vue&type=template&id=29be52e4&scoped=true", function () {
      api.rerender('29be52e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cont/Brand.vue"
export default component.exports